import { SVGProps, Ref, forwardRef } from "react";

const ArchivedIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 26 24"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Archived Icon"
    {...props}
  >
    <title id="Archived Icon">Archived Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M22.917 7.333V16.9c0 1.96 0 2.94-.382 3.689a3.5 3.5 0 0 1-1.53 1.53c-.748.381-1.728.381-3.688.381H8.683c-1.96 0-2.94 0-3.689-.381a3.5 3.5 0 0 1-1.53-1.53c-.38-.749-.38-1.729-.38-3.689V7.333M3.2 1.5h19.6c.653 0 .98 0 1.23.127.22.112.398.29.51.51.127.25.127.576.127 1.23v2.1c0 .653 0 .98-.128 1.23a1.17 1.17 0 0 1-.51.51c-.249.126-.576.126-1.23.126H3.2c-.652 0-.98 0-1.229-.127a1.167 1.167 0 0 1-.51-.51c-.127-.25-.127-.576-.127-1.23v-2.1c0-.653 0-.98.127-1.229.112-.22.29-.398.51-.51.25-.127.577-.127 1.23-.127Zm7 9.917h5.6c.653 0 .98 0 1.23.127.22.112.398.29.51.51.127.25.127.576.127 1.23v.933c0 .653 0 .98-.128 1.23a1.17 1.17 0 0 1-.51.51c-.249.126-.576.126-1.23.126h-5.6c-.652 0-.98 0-1.229-.127a1.167 1.167 0 0 1-.51-.51c-.127-.25-.127-.576-.127-1.23v-.933c0-.653 0-.98.127-1.23.112-.219.29-.397.51-.51.25-.126.577-.126 1.23-.126Z"
    />
  </svg>
);

const ForwardRef = forwardRef(ArchivedIcon);
export default ForwardRef;
